'use strict';//Indicating browser should run only in java script mode

var EMRPrescriptionBenifit270_271Module = angular.module('EMR.PrescriptionBenifit270_271Module', ['EMR.Admin'])